// @flow

import { connect } from "react-redux";

import Options from "src/components/chatroom/NewRoom/Options";

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Options);
